import React from 'react';
import {Button, TextArea, Select, Icon} from '@gravity-ui/uikit';
import {Plus, TrashBin} from '@gravity-ui/icons';
import {StoryParagraphModel} from '../../../entities';
import styles from './ParagraphsEditor.module.scss';

interface ParagraphsEditorProps {
  paragraphs: StoryParagraphModel[];
  onChange: (paragraphs: StoryParagraphModel[]) => void;
  label?: string;
  placeholder?: string;
}

const styleOptions = [
  {value: 'h1', content: 'h1'},
  {value: 'p2', content: 'p2'},
  {value: 'c1', content: 'c1'},
];

export const ParagraphsEditor = ({
  paragraphs,
  onChange,
  label = 'Текстовые блоки',
  placeholder = 'Введите текст',
}: ParagraphsEditorProps) => {
  const handleAddParagraph = () => {
    const newParagraph: StoryParagraphModel = {
      style: 'h1',
      text: '',
    };
    onChange([...paragraphs, newParagraph]);
  };

  const handleRemoveParagraph = (index: number) => {
    const updatedParagraphs = paragraphs.filter((_, i) => i !== index);
    onChange(updatedParagraphs);
  };

  const handleTextChange = (index: number, text: string) => {
    const updatedParagraphs = paragraphs.map((paragraph, i) => (i === index ? {...paragraph, text} : paragraph));
    onChange(updatedParagraphs);
  };

  const handleStyleChange = (index: number, style: string) => {
    const updatedParagraphs = paragraphs.map((paragraph, i) => (i === index ? {...paragraph, style} : paragraph));
    onChange(updatedParagraphs);
  };

  return (
    <div className={styles.container}>
      <div className={styles.paragraphs}>
        {paragraphs.map((paragraph, index) => (
          <div key={index} className={styles.paragraphRow}>
            <label className={styles.label}>{label}</label>

            <TextArea
              size="xl"
              className={styles.textArea}
              value={paragraph.text}
              placeholder={placeholder}
              onChange={(e) => handleTextChange(index, e.target.value)}
              minRows={5}
              maxRows={7}
            />

            <div className={styles.styleSelect}>
              <Select
                size="xl"
                value={[paragraph.style]}
                onUpdate={(values) => handleStyleChange(index, values[0])}
                options={styleOptions}
              />
            </div>

            <Button
              view="flat"
              size="m"
              onClick={() => handleRemoveParagraph(index)}
              disabled={paragraphs.length === 1}>
              <Icon data={TrashBin} />
            </Button>
          </div>
        ))}

        <Button className={styles.addButton} view="normal" size="l" width="max" onClick={handleAddParagraph}>
          <Icon data={Plus} />
        </Button>

        {paragraphs.length === 0 && (
          <div className={styles.emptyState}>
            <Button view="outlined" size="l" onClick={handleAddParagraph}>
              <Icon data={Plus} />
              Добавить первый текстовый блок
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
